import { mdiFlagVariant, mdiMedalOutline } from "@mdi/js";
import Icon from "@mdi/react";
import "animate.css";
import "./index.css";

import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Atuacao() {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);
    return (
        <section id="processo" className="portfolio section">
            <div className="container section-title" data-aos="fade-up">
                <div>
                    <span>Entenda o</span> <span className="description-title">Processo</span>
                </div>
            </div>

            <div className="timeline-container ps-3">
                {/* Passo 1: */}
                <div className="timeline-item green-item aos-init" data-aos="fade-right">
                    <div className="timeline-date ms-1">
                        <Icon path={mdiFlagVariant} size={1.8} />{" "}
                    </div>
                    <div className="timeline-content">
                        <h4>Passo 1: Descoberta </h4>
                        <p>Entendemos objetivos, riscos e métricas de sucesso.</p>
                    </div>
                </div>

                {/* Passo 2: */}
                <div className="timeline-item orange-item aos-init" data-aos="fade-left">
                    <div className="timeline-date ms-1">
                        <Icon path={mdiFlagVariant} size={1.8} />{" "}
                    </div>
                    <div className="timeline-content">
                        <h4 className="mb-5">Passo 2: Proposta </h4>
                        <p className="ms-3">Escopo claro, prazos realistas e plano de entregas.</p>
                    </div>
                </div>

                {/* Passo 3: */}
                <div className="timeline-item green-item aos-init" data-aos="fade-right">
                    <div className="timeline-date ms-1">
                        <Icon path={mdiFlagVariant} size={1.8} />{" "}
                    </div>
                    <div className="timeline-content">
                        <h4>Passo 3: MVP </h4>
                        <p>Primeiro valor em produção, rápido e com feedback real.</p>
                    </div>
                </div>

                {/* Passo 4: */}
                <div className="timeline-item orange-item aos-init" data-aos="fade-left">
                    <div className="timeline-date ms-1">
                        <Icon path={mdiFlagVariant} size={1.8} />{" "}
                    </div>
                    <div className="timeline-content">
                        <h4 className="mb-5">Passo 4: Entrega </h4>
                        <p className="ms-3">Documentação, automação de deploy e handover organizado.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 text-center">
                    <div className="d-flex justify-content-center timeline-item aos-init" data-aos="fade-up">
                        <div className="timeline-content final">
                            <p>
                                <Icon className="mb-3 medal" path={mdiMedalOutline} size={3} />
                            </p>
                            <h4>Passo 5: Entrega </h4>
                            <p>Documentação, automação de deploy e handover organizado.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
